import mountEditNomination from './apps/editNomination'
import mountNewNomination from './apps/newNomination'
import mountPurpleRibbonPage from './apps/purpleRibbonPage'
import initReporter from './services/ErrorReporting'
import './scss/vendor/index.scss'
import Vue from 'vue'
import vueCountryRegionSelect from 'vue-country-region-select'
import VTooltip from 'v-tooltip'

Vue.config.productionTip = false
Vue.config.devtools = true

Vue.use(vueCountryRegionSelect)
Vue.use(VTooltip, {
  defaultTrigger: window.innerWidth > 768 ? 'hover focus click' : 'click',
})

initReporter(Vue)
mountEditNomination(Vue, 'EditNominationApp')
mountNewNomination(Vue, 'NewNominationApp')
mountPurpleRibbonPage(Vue, 'PurpleRibbonPage')
